/**
* ...
* @author DefaultUser (Tools -> Custom Arguments...)
*/
/**
 * package: com.inq.stage
 * class: DragResize
 * root Object
 * @constructor
 */
com.inq.stage.DragResize = function() {
	this.className = "DragResize";
	this.styleSaved = "";
	this.cursor = "default";
	this.pDraggerNow = null;
	this.touchIdentifier = com.inq.stage.DragResize.TOUCH_IDENTIFER_UNUSED;
};
$hxClasses['com.inq.stage.DragResize'] = com.inq.stage.DragResize;
/** @private @type {Array} */
com.inq.stage.DragResize.__name__ = ["com","inq","stage","DragResize"];
/** @private @type {null} */
com.inq.stage.DragResize.o = null;

/**
 * typeof
 *
 * $type TFun([{ name => v, t => TDynamic(null), opt => false }],TInst(String,[]))
 * @private
 * @static
 * @param {null}  v 
 * @return {string}
 */
com.inq.stage.DragResize["typeof"] = function(v) {
	return typeof(v);
};


/**
 * Dummy handler to be overriden in sub-classes
 * --------------------- *
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function WhenDone()
 * @public
 * @static
 * @return {void}
 */
com.inq.stage.DragResize.WhenDone = function() {
	if(com.inq.stage.DragResize.instance != null) com.inq.stage.DragResize.instance.whenDone();
	com.inq.stage.DragResize.instance = null;
};


/**
 * stopEvent
 * Prevents the event from taking effect, and stops its propagation.
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * public static function stopEvent(e:Dynamic):Bool
 * @public
 * @static
 * @param {null}  e 
 * @return {boolean}
 */
com.inq.stage.DragResize.stopEvent = function(e) {
	/** @type {Event} */ 
	var ev = !!e?e:Application.application.getPanelWindow().event;
	/*  trace("DragResize.stopEvent(" + ev.type + ")"); */
	if(ev["preventDefault"] != null) ev.preventDefault();
	if(ev["stopPropagation"] != null) ev.stopPropagation();
	return false;
};


/**
 * _removeEventListener
 *
 * $type TFun([{ name => object, t => TDynamic(null), opt => false },{ name => eventName, t => TInst(String,[]), opt => false },{ name => func, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private function _removeEventListener(object:Dynamic, eventName:String, func:Dynamic):Void
 * @private
 * @this com.inq.stage.DragResize
 * @param {null}  object 
 * @param {string}  eventName 
 * @param {null}  func 
 * @return {void}
 */
com.inq.stage.DragResize.prototype._removeEventListener = function(object,eventName,func) {
	if(null != window["removeEventListener"]) object.removeEventListener(eventName,func,false); else if(null != window["detachEvent"]) object.detachEvent("on" + eventName,func); else object["on" + eventName] = null;/* This is for IE */
};


/**
 * _attachEventListener
 *
 * $type TFun([{ name => object, t => TDynamic(null), opt => false },{ name => eventName, t => TInst(String,[]), opt => false },{ name => func, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private function _attachEventListener(object:Dynamic, eventName:String, func:Dynamic):Void
 * @private
 * @this com.inq.stage.DragResize
 * @param {null}  object 
 * @param {string}  eventName 
 * @param {null}  func 
 * @return {void}
 */
com.inq.stage.DragResize.prototype._attachEventListener = function(object,eventName,func) {
	if(null != window["addEventListener"]) /*  FIXME: This should use Capabilities.BindListener */
	object.addEventListener(eventName,func,false); else if(null != window["attachEvent"]) object.attachEvent("on" + eventName,func); else object["on" + eventName] = func;/* This is for IE */
};


/**
 * bindClosures
 *
 * $type TFun([],TEnum(Void,[]))
 * private function bindClosures()
 * @private
 * @this com.inq.stage.DragResize
 * @return {void}
 */
com.inq.stage.DragResize.prototype.bindClosures = function() {
	this.uponTouchStartClosure = $bind(this,this.uponTouchStart);
	this.uponTouchCancelClosure = $bind(this,this.uponTouchCancel);
	this.uponTouchEndClosure = $bind(this,this.uponTouchEnd);
	this.uponTouchDragClosure = $bind(this,this.uponTouchDrag);
	
	this.uponMouseDragStartClosure = $bind(this,this.uponDragStart);
	this.uponMouseOutClosure = $bind(this,this.uponMouseOut);
	this.uponMouseDragClosure = $bind(this,this.uponDrag);
	this.uponMouseDropClosure = $bind(this,this.uponDrop);
};


/**
 * init
 *
 * $type TFun([{ name => o, t => TDynamic(null), opt => false },{ name => oRoot, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * public function init(o:Dynamic, oRoot:Dynamic):Void
 * @public
 * @this com.inq.stage.DragResize
 * @param {Element}  o 
 * @param {Element}  oRoot 
 * @return {void}
 */
com.inq.stage.DragResize.prototype.init = function(o,oRoot) {
	if (com.inq.flash.client.control.FlashPeer.isPersistentWindow()) {
		return;
	}
	/** @type {boolean} */ 
	var fullPage = com.inq.utils.Util.getConfig("fullPage",false);/*  TODO: This is called before config information is processed*/
	if(fullPage) return;
	if(o == null) return;
	/* get the child element to drag.  It will be the "input image" element.
	 * We will use this child (called dragImage) to attach the touch and mouse events
	 */
	this.dragImage = this.fixDragImage(o);
	this.obj = o;
	
	/*  When we close the chat interface, we don't actually destroy */
	/*  the div/img/input nodes that we create on initialization. */
	/*  So, we check the [INSTANCE_LABEL] property here as a flag */
	/*  to see if we've already bound the event handlers.  If we */
	/*  have, then we MUST NOT BIND THEM AGAIN, or we get really */
	/*  strange bugs. */
	if(o[com.inq.stage.DragResize.INSTANCE_LABEL] != null) haxe.Log.trace("o already has property for " + com.inq.stage.DragResize.INSTANCE_LABEL + ": " + o[com.inq.stage.DragResize.INSTANCE_LABEL],{ fileName : "DragResize.hx", lineNumber : 862, className : "com.inq.stage.DragResize", methodName : "init"}); else {
		o[com.inq.stage.DragResize.INSTANCE_LABEL] = this;
		oRoot[com.inq.stage.DragResize.INSTANCE_LABEL] = this;
		
		/* trace("class name is " + this.className); */
		this.root = oRoot && oRoot != null?oRoot:o;
		
		this.bindClosures();
		
		/*  Bind initial event handlers */
		if(this.isSupported("touchstart")) {
			/* trace("binding touchstart to " + (untyped o.tagName) + "#" + (untyped o.id)); */
			this.obj[com.inq.stage.DragResize.INSTANCE_LABEL] = this;
			this._attachEventListener(this.dragImage,"touchstart",this.uponTouchStartClosure);
		}
		if(this.isSupported("mousedown")) this._attachEventListener(this.dragImage,"mousedown",this.uponMouseDragStartClosure);
	}
};


/**
 * fixDragImage - This fixes the drag image and makes it a "input type='image'" instead.
 *
 * $type TFun([{ name => element, t => TType(js.HtmlDom,[]), opt => false }],TDynamic(null))
 * private function fixDragImage(element:HtmlDom):Dynamic
 * @private
 * @this com.inq.stage.DragResize
 * @param {Element}  element -  that is the target for dragging 
 * @return {Element} - input image element for dragging
 */
com.inq.stage.DragResize.prototype.fixDragImage = function(element) {
	/** @type {Node} */
	var par;
	/** @type {number} */
	var _g1 = 0;
	/** @type {number} */
	var _g;
	if(element.nodeName.toUpperCase() == "IMG") {
		/* trace("    binding to IMG"); */
		par = element.parentNode;
		/** @type {Element} */ 
		var div = document.createElement("DIV");
		div.id = element.id;
		div.style.cssText = "background-color:#007700; opacity:0.4; " + Std.string(element.style.cssText);
		div.title = element.title;
		par.insertBefore(div,element);
		
		/* Now fix the image so it fills the entire div */
		element.style.height = element.style.width = "100%";
		element.style.position = "absolute";
		element.style.top = element.style.left = "0px";
		/* Make the image id different from div */
		element.id = div.id + "_image";
		par.removeChild(element);
		return div;
	} else if(element.nodeName.toUpperCase() == "DIV") {
		/* We want to replace the "img" tag with "input image"
		 * So we:
		 * 1) Get list of all images.
		 * 2) Get the image that is a direct child of the parent div
		 * 		This is important because "getElementsByTagName gets all decendents, not just children
		 * 3) replace image with the input image
		 */
		/** @type {NodeList} */
		var images = element.getElementsByTagName("IMG");
		if (images.length > 0) {
			/** @type {Node} */
			var image = null;
			_g1 = 0;
			_g = images.length;
			while (_g1 < _g) {
				/** @type {number} */
				var i1 = _g1++;
				if (images[i1].parentNode == element) {
					image = images[i1];
					break;
				}
			}
			if (image != null) {
				par = image.parentNode;
				if (par == element) {
					/** @type {Element} */
					var dragSafe = document.createElement("INPUT");
					dragSafe.type = "image";
					if(image.src == null || image.src == "") dragSafe.src = Application.application.getClearImage();/* Make sure that the source has the clear image in it */ else dragSafe.src = image.src;/* Make sure that the source has the clear image in it */
					dragSafe.style.cssText = Std.string(element.style.cssText) + "; top:0px; left:0px; height: 100%; width: 100%;display:block;padding:0;margin:0;";
					dragSafe.className = "tcChat";
					dragSafe.name = "DragSafe";/* We make the name "DragSafe" so that we can find it during debug */
					addAriaToDrag(dragSafe);
					par.replaceChild(dragSafe,image);
					return dragSafe;
				}
			}
		}
		
		/* Now find the first input element that belongs to the DIV as a direct decendant (child)
		 * and we
		 */
		/** @type {Element} */
		var inputEl = null;
		/** @type {NodeList} */
		var inputs = element.getElementsByTagName("INPUT");
		if (inputs.length > 0) {
			_g1 = 0;
			_g = inputs.length;
			while (_g1 < _g) {
				/** @type {number} */
				var i = _g1++;
				if (inputs[i].parentNode == element) {
					inputEl = inputs[i];
					break;
				}
			}
			if (inputEl != null && inputEl.name != "DragSafe") {
				inputEl.name = "DragSafe";
				/* We make the name "DragSafe" so that we can find it during debug */
				inputEl.style.cssText = Std.string(element.style.cssText) + "; top:0px; left:0px; height: 100%; width: 100%;display: block;padding:0;margin:0;";
				inputEl.className = "tcChat";
				addAriaToDrag(inputEl);
			}
		}
		/* According issue RTDEV-7155 input elements on the client's page may be changed.
		 * Therefore we need to use parent element instead input element to attach handler.
	     * Before this was returning an inputEl.
		 */
	}

	/**
	 * Its a utility function created to remove code duplicity
	 * @param el
	 */
	function addAriaToDrag(el) {
		el.setAttribute("aria-hidden", "true");
		el.setAttribute("alt", "");
		el.setAttribute("tabindex", "-1");
	}
	return element;
};


/**
 * isLeftClick: Test for left button click, this is only to be used from mousedown
 * Please note: Gecko uses which, button is unreliable within gecko versions and vendors.
 * Use button for IE
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private function isLeftClick(e:Dynamic):Bool
 * @private
 * @this com.inq.stage.DragResize
 * @param {null}  e - event 
 * @return {boolean}
 */
com.inq.stage.DragResize.prototype.isLeftClick = function(e) {
	/** @type {Event} */ 
	var ev = !!e?e:Application.application.getPanelWindow().event;
	/** @type {number} */ 
	var mouseButtonState = 1;
	/*Assume Left button */
	if(window.navigator.appName == "Netscape") mouseButtonState = e.which; else mouseButtonState = window.parent.event.button;
	if(ev.type.indexOf("touch") == 0) return true;
	return mouseButtonState == 1;
};


/**
 * fireDone
 *
 * $type TFun([],TEnum(Void,[]))
 * public function fireDone():Void
 * @public
 * @this com.inq.stage.DragResize
 * @return {void}
 */
com.inq.stage.DragResize.prototype.fireDone = function() {
	this.whenDone();
};


/**
 * fireDoneState
 *
 * $type TFun([],TEnum(Void,[]))
 * public function fireDoneState():Void
 * @public
 * @this com.inq.stage.DragResize
 * @return {void}
 */
com.inq.stage.DragResize.prototype.fireDoneState = function() {
	com.inq.stage.DragResize.instance = this;
	window.setTimeout(com.inq.stage.DragResize.WhenDone,1);
};


/**
 * removeTouchEvents - Unbind the drag/drag end event handlers, and restore the mousedown handler.
 *
 * $type TFun([],TEnum(Void,[]))
 * private function removeTouchEvents():Void
 * @private
 * @this com.inq.stage.DragResize
 * @return {void}
 */
com.inq.stage.DragResize.prototype.removeTouchEvents = function() {
	this._attachEventListener(this.dragImage,"mousedown",this.uponMouseDragStartClosure);/*  Restore mouse handler*/
	this._removeEventListener(com.inq.stage.DragResize.doc,"touchcancel",this.uponTouchCancelClosure);/*  Remove touch handlers.*/
	this._removeEventListener(com.inq.stage.DragResize.doc,"touchend",this.uponTouchEndClosure);
	this._removeEventListener(com.inq.stage.DragResize.doc,"touchmove",this.uponTouchDragClosure);
};


/**
 * removeMouseEvents - remove all the mouse hooks when we are done dragging or resizing
 *
 * $type TFun([],TEnum(Void,[]))
 * private function removeMouseEvents():Void
 * @private
 * @this com.inq.stage.DragResize
 * @return {void}
 */
com.inq.stage.DragResize.prototype.removeMouseEvents = function() {
	this._attachEventListener(this.dragImage,"touchstart",this.uponTouchStartClosure);/*  Restore touch handler*/
	this._removeEventListener(com.inq.stage.DragResize.doc,"mouseout",this.uponMouseOutClosure);/*  Remove mouse hanlders.*/
	this._removeEventListener(com.inq.stage.DragResize.doc,"mousemove",this.uponMouseDragClosure);
	this._removeEventListener(com.inq.stage.DragResize.doc,"mouseup",this.uponMouseDropClosure);
};


/**
 * addTouchEvents
 *
 * $type TFun([],TEnum(Void,[]))
 * private function addTouchEvents():Void
 * @private
 * @this com.inq.stage.DragResize
 * @return {void}
 */
com.inq.stage.DragResize.prototype.addTouchEvents = function() {
	this._removeEventListener(this.dragImage,"mousedown",this.uponMouseDragStartClosure);/*  Temp. remove the mouse handler*/
	this._attachEventListener(com.inq.stage.DragResize.doc,"touchcancel",this.uponTouchCancelClosure);/*  Bind touch handlers*/
	this._attachEventListener(com.inq.stage.DragResize.doc,"touchend",this.uponTouchEndClosure);
	this._attachEventListener(com.inq.stage.DragResize.doc,"touchmove",this.uponTouchDragClosure);
};


/**
 * addMouseEvents
 *
 * $type TFun([],TEnum(Void,[]))
 * private function addMouseEvents():Void
 * @private
 * @this com.inq.stage.DragResize
 * @return {void}
 */
com.inq.stage.DragResize.prototype.addMouseEvents = function() {
	this._removeEventListener(this.obj,"touchstart",this.uponTouchStartClosure);/*  Temp. remove the touch handler.*/
	this._attachEventListener(com.inq.stage.DragResize.doc,"mouseout",this.uponMouseOutClosure);/*  Bind mouse handlers.*/
	this._attachEventListener(com.inq.stage.DragResize.doc,"mousemove",this.uponMouseDragClosure);
	this._attachEventListener(com.inq.stage.DragResize.doc,"mouseup",this.uponMouseDropClosure);
};


/**
 * removeEvents - remove all the mouse hooks when we are done dragging or resizing
 *
 * $type TFun([],TEnum(Void,[]))
 * private function removeEvents():Void
 * @private
 * @this com.inq.stage.DragResize
 * @return {void}
 */
com.inq.stage.DragResize.prototype.removeEvents = function() {
	this.removeMouseEvents();
	/* 	removeTouchEvents(); */
	this.fireDoneState();
};


/**
 * uponTouchCancel
 * uponTouchEnd - onmouseup handler
 * Note:  There is a static intance of this class,
 * This should be no problem, There is only one mouse up event at a time.
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private function uponTouchCancel(e:Dynamic):Bool
 * @private
 * @this com.inq.stage.DragResize
 * @param {null}  e - event information (non-IE), null (IE) 
 * @return {boolean}
 */
com.inq.stage.DragResize.prototype.uponTouchCancel = function(e) {
	/** @type {Event} */ 
	var ev = !!e?e:Application.application.getPanelWindow().event;
	if(ev["preventDefault"] != null) ev.preventDefault();
	return false;
};


/**
 * uponTouchEnd - onmouseup handler
 * Note:  There is a static intance of this class,
 * This should be no problem, There is only one mouse up event at a time.
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private function uponTouchEnd(e:Dynamic):Bool
 * @private
 * @this com.inq.stage.DragResize
 * @param {null}  e - event information (non-IE), null (IE) 
 * @return {boolean}
 */
com.inq.stage.DragResize.prototype.uponTouchEnd = function(e) {
	try {
		/** @type {Event} */
		var ev = !!e?e:Application.application.getPanelWindow().event;
		if(ev["preventDefault"] != null) ev.preventDefault();
		this.touch = this.getTouchByIdentifer(ev);
		if(this.touch == null) return false;
		this.restoreStyle();
		/** @type {Object} */
		var pCur = {X: this.touch.pageX - this.touchOffsetX, Y: this.touch.pageY - this.touchOffsetY};
		
		this.repositionTouch(pCur);
		this.removeTouchEvents();
		this.done();
	} catch( e1 ) {
		window.alert("ERROR: uponTouchEnd: " + Std.string(e1));
	}
	return false;
};


/**
 * getTouchByIdentifer
 *
 * $type TFun([{ name => ev, t => TDynamic(null), opt => false }],TDynamic(null))
 * private function getTouchByIdentifer(ev:Dynamic):Dynamic
 * @private
 * @this com.inq.stage.DragResize
 * @param {null}  ev 
 * @return {null}
 */
com.inq.stage.DragResize.prototype.getTouchByIdentifer = function(ev) {
	try {
		/** @type {Array} */ 
		var touchList = ev.changedTouches;
		if(touchList == null) return null;
		if(this.touchIdentifier == com.inq.stage.DragResize.TOUCH_IDENTIFER_UNUSED) return null;
		if(touchList["identifiedTouch"] == null) {
			/*   identifiedTouch not implemented in safari even though in W3C specification */
			/** @type {number} */
			var _g1 = 0;
			/** @type {number} */ 
			var _g = touchList.length;
			while(_g1 < _g) {
				/** @type {number} */
				var i1 = _g1++;
				if(touchList[i1].identifier == this.touchIdentifier) return touchList[i1];
			}
			return null;
		} else return touchList.identifiedTouch(this.touchIdentifier);
	} catch( e ) {
		
		window.alert("ERROR: getTouchByIdentifer: " + Std.string(e));
	}
	return null;
};


/**
 * done
 *
 * $type TFun([],TEnum(Void,[]))
 * private function done():Void
 * @private
 * @this com.inq.stage.DragResize
 * @return {void}
 */
com.inq.stage.DragResize.prototype.done = function() {
	this.touchIdentifier = com.inq.stage.DragResize.TOUCH_IDENTIFER_UNUSED;
	this.restoreStyle();
	window.setTimeout($bind(this,this.whenDone),1);
};


/**
 * uponDrop - onmouseup handler
 * Note:  There is a static intance of this class,
 * This should be no problem, There is only one mouse up event at a time.
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private function uponDrop(e:Dynamic):Bool
 * @private
 * @this com.inq.stage.DragResize
 * @param {null}  e - event information (non-IE), null (IE) 
 * @return {boolean}
 */
com.inq.stage.DragResize.prototype.uponDrop = function(e) {
	/** @type {Event} */ 
	var ev = !!e?e:Application.application.getPanelWindow().event;
	if(ev["preventDefault"] != null) ev.preventDefault();

	/** @type {Object} */
	var pCur = this.getPosition(ev);
	this.removeEvents();
	this.done();
	return this.reposition(pCur);
};


/**
 * uponMouseOut - onmouseout handler
 * If this is triggered, then the mouse position has left the page.
 * If this is the case, we will not see the mouseup event and positioning will be broken
 * So, when mouse leaves the page, assume mouse up.
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private function uponMouseOut(e:Dynamic):Bool
 * @private
 * @this com.inq.stage.DragResize
 * @param {null}  e 
 * @return {boolean}
 */
com.inq.stage.DragResize.prototype.uponMouseOut = function(e) {
	/** @type {Event} */ 
	var ev = !!e?e:Application.application.getPanelWindow().event;
	if(ev["preventDefault"] != null) ev.preventDefault();
	/** @type {Object} */ 
	var pCur = this.getPosition(ev);
	/** @type {boolean} */ 
	var outOfArea = false;
	/** @type {Object} */ 
	var pMax = this.getScreenMax();
	
	if(pCur.Y < 0) {
		pCur.Y = 0;
		outOfArea = true;
	}
	if(pCur.X < 0) {
		pCur.X = 0;
		outOfArea = true;
	}
	if(pCur.Y >= pMax.Y) {
		pCur.Y = pMax.Y;
		outOfArea = true;
	}
	if(pCur.X >= pMax.X) {
		pCur.X = pMax.X;
		outOfArea = true;
	}
	if(outOfArea) {
		/* trace ("X,Y = " + pCur.X + "," + pCur.Y); */
		this.removeEvents();
		this.restoreStyle();
		this.reposition(pCur);
		this.fireDoneState();
		return false;
	}
	/* trace("unexpected out of area X,Y = " + pCur.X + "," + pCur.Y); */
	return this.uponDrag(ev);
};


/**
 * getScreenMax - Maximum X and Y coordinates of the viewable area of customer window

 * @private
 * @this com.inq.stage.DragResize
 * @return {Object} -  coordinates
 */
com.inq.stage.DragResize.prototype.getScreenMax = function() {
	return { X : com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft() + com.inq.flash.client.chatskins.ScrollMonitor.getScrollWidth(), Y : com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop() + com.inq.flash.client.chatskins.ScrollMonitor.getScrollHeight()};
};


/**
 * repositionTouch
 *
 * $type TFun([{ name => pCur, t => TAnonymous(<anonymous>), opt => false }],TEnum(Bool,[]))
 * private function repositionTouch(pCur):Bool
 * @private
 * @this com.inq.stage.DragResize
 * @param {TAnonymous(<anonymous>)}  pCur 
 * @return {boolean}
 */
com.inq.stage.DragResize.prototype.repositionTouch = function(pCur) {
	try {
		/* If no movement since the last check, then return */
		if(this.pLast != null && pCur.X == this.pLast.X && pCur.Y == this.pLast.Y) return false;
		/** @type {number} */ 
		var top;
		/** @type {number} */ 
		var left;
		
		left = pCur.X;
		if(pCur.X != this.pLast.X && left >= this.pMin.X && left < this.pMax.X) this.setLeft(left); else /* if x-axis movement in the valid area then reposition Left */
		if(left >= this.pMax.X) this.setLeft(left = this.pMax.X); else /* if x-axis movement more than maximum, then use maximum */
		if(left < this.pMin.X) this.setLeft(left = this.pMin.X);
		/* if x-axis movement less than minimum, then use minimum */
		
		top = pCur.Y;
		if(pCur.Y != this.pLast.Y && top >= this.pMin.Y && top < this.pMax.Y) this.setTop(top); else /* if y-axis movement in the valid area then reposition Top */
		if(top >= this.pMax.Y) this.setTop(top = this.pMax.Y); else /* if y-axis movement more than maximum, then use maximum */
		if(top < this.pMin.Y) this.setTop(top = this.pMin.Y);
		/* if y-axis movement less than minimum, then use minimum */
		
		
		this.pDraggerNow = { X : left, Y : top};
		
		this.pLast = pCur;
	} catch( e ) {
		window.alert("ERROR: repositionTouch: " + Std.string(e));
	}
	return false;
};


/**
 * reposition - onmousemove handler
 * This function change current chat position when we drag chat window.
 *
 * This routine gets a lot of action and should not be overly large.
 * It uses <b>setLeft</b> and <b>setTop</b> for positioning.
 * These are overrided in Resize and Drag
 *
 * @private
 * @this com.inq.stage.DragResize
 * @see com.inq.stage.DragResize.prototype.setTop
 * @see com.inq.stage.DragResize.prototype.setLeft
 * @param {Object}   pCur Object with previous chat coordinates
 * @return {boolean} it is always return false.
 */
com.inq.stage.DragResize.prototype.reposition = function(pCur) {

	/** @type {number} */
	var top = pCur.Y - this.deltaY;
	/** @type {number} */ 
	var left = pCur.X - this.deltaX;

		/*
		 * We should move chat outside from window border when it is drag event,
		 * and chat size bigger than page, size else we look for chat stay inside the page
		 * if x-axis movement in the valid area then reposition Left
		 * if x-axis movement more than maximum, then use maximum
		 * if x-axis movement less than minimum, then use minimum
		 * if y-axis movement in the valid area then reposition Top
		 * if y-axis movement more than maximum, then use maximum
		 * if y-axis movement less than minimum, then use minimum
		 * NOTE: When we drag chat outside from window our drag area based on page size.
		*/
	if (this.pDraggerNow.X > this.pMax.X || this.pDraggerNow.Y > this.pMax.Y) {
		if (left < this.pMin.X) {
			this.pDraggerNow.X = this.pMin.X;
		} else if (left >= parent.window.document.body.scrollWidth) {
			this.pDraggerNow.X = parent.window.document.body.scrollWidth;
		} else {
			this.pDraggerNow.X = left;
		}
		if (top < this.pMin.Y) {
			this.pDraggerNow.Y = this.pMin.Y;
		} else if (top >= parent.window.document.body.scrollHeight) {
			this.pDraggerNow.Y = parent.window.document.body.scrollHeight;
		} else {
			this.pDraggerNow.Y = top;
		}
	} else {
		if (left >= this.pMin.X && left < this.pMax.X) {
			this.pDraggerNow.X = left;
		} else if (left >= this.pMax.X) {
			this.pDraggerNow.X = this.pMax.X;
		} else if (left < this.pMin.X) {
			this.pDraggerNow.X = this.pMin.X;
		}
		if (top >= this.pMin.Y && top < this.pMax.Y) {
			this.pDraggerNow.Y = top;
		} else if (top >= this.pMax.Y) {
			this.pDraggerNow.Y = this.pMax.Y;
		} else if (top < this.pMin.Y) {
			this.pDraggerNow.Y = this.pMin.Y;
		}
	}
	// after check and fix coordinates we set this coordinates for chat,
	// and also set current position as last.
	this.setTop(this.pDraggerNow.Y);
	this.setLeft(this.pDraggerNow.X);
	this.pLast = pCur;
	return false;
};


/**
 * uponTouchDrag
 * For touch, we want to get the touch structure
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private function uponTouchDrag(e:Dynamic):Bool
 * @private
 * @this com.inq.stage.DragResize
 * @param {null}  e - event structure (non IE only) 
 * @return {boolean} - false;
 */
com.inq.stage.DragResize.prototype.uponTouchDrag = function(e) {
	/** @type {Event} */ 
	var ev = !!e?e:Application.application.getPanelWindow().event;
	if(ev["preventDefault"] != null) ev.preventDefault();
	try {
		/* trace("uponTouchDrag"); */
		this.touch = this.getTouchByIdentifer(ev);
		if(this.touch == null) return false;
		/** @type {Object} */
		var pCur = {X: this.touch.pageX - this.touchOffsetX, Y: this.touch.pageY - this.touchOffsetY};
		
		/* trace("" + this.className + " { X:" + touch.pageX + ",Y:" + touch.pageY + " } " + " offset ("+this.touchOffsetX+","+this.touchOffsetY+") "); */
		
		this.repositionTouch(pCur);
	} catch( e1 ) {
		
		window.alert("uponTouchDrag ERROR: " + Std.string(e1));
	}
	return false;
};


/**
 * uponDrag - onmousemove handler
 * This routine gets a lot of action and should not be overly large.
 * It uses <b>setLeft</b> and <b>setTop</b> for positioning. These are overrided in Resize and Drag
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private function uponDrag(e:Dynamic):Bool
 * @private
 * @this com.inq.stage.DragResize
 * @author  Fred A. Pinn (fpinn@touchcommerce.com)
 * @see  setTop, setLeft
 * @param {null}  e - event information (non-IE), null (IE) 
 * @return {boolean}
 */
com.inq.stage.DragResize.prototype.uponDrag = function(e) {
	/** @type {Event} */ 
	var ev = !!e?e:Application.application.getPanelWindow().event;
	if(!!this.obj.dragging) return false;
	this.obj["dragging"] = true;
	if(ev["preventDefault"] != null) ev.preventDefault();
	/** @type {Object} */ 
	var pCur = this.getPosition(ev);
	/* trace("uponDrag: ("+pCur.X+","+pCur.Y+") "+mouseDown+" "); */
	this.reposition(pCur);
	this.obj["dragging"] = false;
	return false;
};


/**
 * uponDragOverFromStage - mouse up handler for inside the IFRAME
 * If the customer drags the mouse over the IFRAME,
 * then the client document stops getting mouse motion or mouse up events!
 * So we get them from our IFRAME and get the position relative to the client's body
 * and perform the mouse over processing as done in uponDrag
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private function uponDragOverFromStage(e:Dynamic):Bool
 * @private
 * @this com.inq.stage.DragResize
 * @see		uponDrag
 * @param {null}  e - event stucture 
 * @return {boolean} - boolean false
 */
com.inq.stage.DragResize.prototype.uponDragOverFromStage = function(e) {
	/** @type {Event} */ 
	var ev = !!e?e:Application.application.getPanelWindow().event;
	if(ev["preventDefault"] != null) ev.preventDefault();
	/** @type {Object} */ 
	var pCur = this.getAbsolutePosition(ev);
	this.reposition(pCur);
	return false;
};


/**
 * uponDragEndFromStage - mouse up handler for inside the IFRAME
 * If the customer drags the mouse over the IFRAME,
 * then the client document stops getting mouse motion or mouse up events!
 * So we get them from our IFRAME and get the position relative to the client's body
 * and perform the Drag End processing as in uponDrop
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private function uponDragEndFromStage(e:Dynamic):Bool
 * @private
 * @this com.inq.stage.DragResize
 * @see		uponDrop
 * @param {null}  e - event stucture 
 * @return {boolean} - boolean false
 */
com.inq.stage.DragResize.prototype.uponDragEndFromStage = function(e) {
	/** @type {Event} */ 
	var ev = !!e?e:Application.application.getPanelWindow().event;
	if(ev["preventDefault"] != null) ev.preventDefault();
	/** @type {Object} */ 
	var pCur = this.getAbsolutePosition(ev);
	this.removeEvents();
	this.restoreStyle();
	this.reposition(pCur);
	/* trace("drag " + ev.type); */
	this.fireDoneState();
	return false;
};


/**
 * uponTouchStart
 * uponDragStart - onmousedown
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private  function uponTouchStart(e:Dynamic):Bool
 * @private
 * @this com.inq.stage.DragResize
 * @see uponDragStart
 * @author Fred A. Pinn <fpinn@TouchCommerce.com>
 * @param {null}  e - event on non IE browsers, null on IE browsers 
 * @return {boolean} - true;
 */
com.inq.stage.DragResize.prototype.uponTouchStart = function(e) {
	/** @type {Event} */ 
	var ev = !!e?e:Application.application.getPanelWindow().event;
	if(ev["preventDefault"] != null) ev.preventDefault();

	/** @type {Element} */
	var o = this.obj;
	
	/* trace("    Setting pStart"); */
	this.pStart = { X : Std.parseInt(this.root.style["left"]), Y : Std.parseInt(this.root.style["top"])};

	/** @type {CSSStyleDeclaration} */
	var style = o.style;
	
	if(this.touchIdentifier != com.inq.stage.DragResize.TOUCH_IDENTIFER_UNUSED) return false;
	this.touch = ev.changedTouches[0];
	this.touchOffsetX = Math.round(this.touch.pageX) - Std.parseInt(style.left);
	this.touchOffsetY = Math.round(this.touch.pageY) - Std.parseInt(style.top);
	this.touchIdentifier = this.touch.identifier;
	
	this.pMin = this.getDefaultMin();
	this.pMax = this.getDefaultMax();
	
	this.saveStyle();
	o.style["cursor"] = this.cursor;
	
	
	this.addTouchEvents();
	/*  Bind the closuers as event handlers. */
	
	this.setDragBorder();
	this.pLast = { X : this.touch.pageX - this.clickOffsetX, Y : this.touch.pageY - this.clickOffsetY};
	return false;
};


/**
 * uponDragStart - onmousedown
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private  function uponDragStart(e:Dynamic):Bool
 * @private
 * @this com.inq.stage.DragResize
 * @see uponDragStart
 * @author Fred A. Pinn <fpinn@TouchCommerce.com>
 * @param {Event}  e - event on non IE browsers, null on IE browsers 
 * @return {boolean} - true;
 */
com.inq.stage.DragResize.prototype.uponDragStart = function(e) {
	/** @type {Event} */
	var ev = !!e ? e : Application.application.getPanelWindow().event;
	if(ev["preventDefault"] != null) ev.preventDefault();

	/** @type {Element} */
	var o = this.obj;
	if(!this.isLeftClick(ev)) return false;
	this.pStart = { X : Std.parseInt(this.root.style["left"]), Y : Std.parseInt(this.root.style["top"])};
	
	this.pDraggerStart = { X : Std.parseInt(o.style["left"]), Y : Std.parseInt(o.style["top"])};
	this.draggerHeight = Std.parseInt(o.style.height);
	this.draggerWidth = Std.parseInt(o.style.width);
	
	this.pDraggerNow = { X : this.pDraggerStart.X, Y : this.pDraggerStart.Y};
	this.pLast = this.getPosition(ev);
	
	this.deltaX = this.pLast.X - this.pDraggerStart.X;
	this.deltaY = this.pLast.Y - this.pDraggerStart.Y;
	
	this.pMin = this.getDefaultMin();
	this.pMax = this.getDefaultMax();
	this.saveStyle();
	o.style["cursor"] = this.cursor;
	this.setDragBorder();
	com.inq.stage.DragResize.instance = this;
	this.addMouseEvents();
	
	return false;
};


/**
 * Dummy handler to be overriden in sub-classes
 * --------------------- *
 *
 * $type TFun([],TEnum(Void,[]))
 * private function setDragBorder():Void
 * @private
 * @this com.inq.stage.DragResize
 * @return {void}
 */
com.inq.stage.DragResize.prototype.setDragBorder = function() {
};


/**
 * Dummy handler to be overriden in sub-classes
 * --------------------- *
 *
 * $type TFun([],TDynamic(null))
 * private function getDefaultMax():Dynamic
 * @private
 * @this com.inq.stage.DragResize
 * @return {null}
 */
com.inq.stage.DragResize.prototype.getDefaultMax = function() {
	return { X : 10000, Y : 10000};
};


/**
 * Dummy handler to be overriden in sub-classes
 * --------------------- *
 *
 * $type TFun([],TDynamic(null))
 * private function getDefaultMin():Dynamic
 * @private
 * @this com.inq.stage.DragResize
 * @return {null}
 */
com.inq.stage.DragResize.prototype.getDefaultMin = function() {
	return { X : 0, Y : 0};
};


/**
 * Dummy handler to be overriden in sub-classes
 * --------------------- *
 *
 * $type TFun([{ name => top, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * private function setLeft(top:Int):Void
 * @private
 * @this com.inq.stage.DragResize
 * @param {number}  top 
 * @return {void}
 */
com.inq.stage.DragResize.prototype.setLeft = function(top) {
	window.alert("setLeft override failed");
};


/**
 * Dummy handler to be overriden in sub-classes
 * --------------------- *
 *
 * $type TFun([{ name => top, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * private function setTop(top:Int):Void
 * @private
 * @this com.inq.stage.DragResize
 * @param {number}  top 
 * @return {void}
 */
com.inq.stage.DragResize.prototype.setTop = function(top) {
	window.alert("setTop override failed");
};


/**
 * whenDone is invoked following the mouse up event in uponDrop function
 * It is invoked via the setTimeout functiona and is NOT in the same thread as the
 * event handler.  This is by design so not to delay further event handling.
 *
 * $type TFun([],TEnum(Void,[]))
 * public function whenDone ():Void
 * @public
 * @this com.inq.stage.DragResize
 * @return {void}
 */
com.inq.stage.DragResize.prototype.whenDone = function() {
};


/**
 * getAbsolutePosition
 * getAbsolute - get absolute location relative to the body
 *
 * $type TFun([{ name => e, t => TAnonymous(<anonymous>), opt => false }],TDynamic(null))
 * private function getAbsolutePosition(e):Dynamic
 * @private
 * @this com.inq.stage.DragResize
 * @param {TAnonymous(<anonymous>)}  e - event structure 
 * @return {Object} -  coordinates
 */
com.inq.stage.DragResize.prototype.getAbsolutePosition = function(e) {
	/** @type {Object} */ 
	var loc = this.getPosition(e);
	/** @type {Element} */ 
	var p = window.frameElement;
	while(p != null) {
		loc.X += p.offsetLeft;
		loc.Y += p.offsetTop;
		p = p.offsetParent;
		if(p.tagName == "BODY") break;
	}
	return loc;
};


/**
 * getTarget - get the target object from the event
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TDynamic(null))
 * private function getTarget(e:Dynamic):Dynamic
 * @private
 * @this com.inq.stage.DragResize
 * @usage used below by getAbsolutePosition
 * @param {Event}  e - event structure 
 * @return {Node} - target element
 */
com.inq.stage.DragResize.prototype.getTarget = function(e) {
	/** @type {Node} */ 
	var t = null;
	if(!e) e = Application.application.getPanelWindow().event;
	if(e.target) t = e.target; else if(e.srcElement) t = e.srcElement;
	if(t.nodeType == 3) t = t.parentNode;/*  defeat Safari bug*/
	return t;
};


/**
 * isSupported - Determine whether the given event type is supported in the current browser.
 *
 * $type TFun([{ name => eventType, t => TInst(String,[]), opt => false }],TEnum(Bool,[]))
 * public function isSupported(eventType:String):Bool
 * @public
 * @this com.inq.stage.DragResize
 * @param {string}  eventType - The type of event in question 
 * @return {boolean} - boolean - Tells whether the given event type is supported.
 */
com.inq.stage.DragResize.prototype.isSupported = function(eventType) {
	return "on"+eventType in document.documentElement;
};


/**
 * restoreStyle - Save the style from the bound draggable object so we
 * can restore it later.
 *
 * $type TFun([],TEnum(Void,[]))
 * private function restoreStyle():Void
 * @private
 * @this com.inq.stage.DragResize
 * @return {void}
 */
com.inq.stage.DragResize.prototype.restoreStyle = function() {
	this.obj.style.cssText = this.styleSaved;
};


/**
 * saveStyle - Save the style from the bound draggable object so we
 * can restore it later.
 *
 * $type TFun([],TEnum(Void,[]))
 * private function saveStyle():Void
 * @private
 * @this com.inq.stage.DragResize
 * @return {void}
 */
com.inq.stage.DragResize.prototype.saveStyle = function() {
	this.styleSaved = this.obj.style.cssText;
};


/**
 * getPositionIE
 *
 * $type TFun([{ name => e, t => TMono(<mono>), opt => false }],TDynamic(null))
 * public function getPositionIE(e):Dynamic
 * @public
 * @this com.inq.stage.DragResize
 * @param {TMono(<mono>)}  e 
 * @return {null}
 */
com.inq.stage.DragResize.prototype.getPositionIE = function(e) {
	return { X : window.parent.event.clientX, Y : window.parent.event.clientY};
};


/**
 * getPositionGecko
 *
 * $type TFun([{ name => e, t => TAnonymous(<anonymous>), opt => false }],TDynamic(null))
 * public function getPositionGecko(e):Dynamic
 * @public
 * @this com.inq.stage.DragResize
 * @param {TAnonymous(<anonymous>)}  e 
 * @return {null}
 */
com.inq.stage.DragResize.prototype.getPositionGecko = function(e) {
	return { X : e.clientX, Y : e.clientY};
};


/**
 * getPosition
 *
 * @public
 * @this com.inq.stage.DragResize
 * @param {Object}  e 
 * @return {Object}
 */
com.inq.stage.DragResize.prototype.getPosition = function(e) {
	return { X : e.clientX, Y : e.clientY};
};

/** @private @type {null} */
com.inq.stage.DragResize.prototype.uponMouseDropClosure = null;
/** @private @type {null} */
com.inq.stage.DragResize.prototype.uponMouseDragClosure = null;
/** @private @type {null} */
com.inq.stage.DragResize.prototype.uponMouseOutClosure = null;
/** @private @type {null} */
com.inq.stage.DragResize.prototype.uponMouseDragStartClosure = null;
/** @private @type {null} */
com.inq.stage.DragResize.prototype.uponTouchDragClosure = null;
/** @private @type {null} */
com.inq.stage.DragResize.prototype.uponTouchEndClosure = null;
/** @private @type {null} */
com.inq.stage.DragResize.prototype.uponTouchCancelClosure = null;
/** @private @type {null} */
com.inq.stage.DragResize.prototype.uponTouchStartClosure = null;
/** @private @type {number} */
com.inq.stage.DragResize.prototype.deltaY = null;
/** @private @type {number} */
com.inq.stage.DragResize.prototype.deltaX = null;
/** @private @type {null} */
com.inq.stage.DragResize.prototype.pMax = null;
/** @private @type {null} */
com.inq.stage.DragResize.prototype.pMin = null;
/** @private @type {number} */
com.inq.stage.DragResize.prototype.rootWidth = null;
/** @private @type {number} */
com.inq.stage.DragResize.prototype.rootHeight = null;
/** @private @type {number} */
com.inq.stage.DragResize.prototype.draggerHeight = null;
/** @private @type {number} */
com.inq.stage.DragResize.prototype.draggerWidth = null;
/** @private @type {null} */
com.inq.stage.DragResize.prototype.pDraggerNow = null;
/** @private @type {null} */
com.inq.stage.DragResize.prototype.pDraggerStart = null;
/** @private @type {null} */
com.inq.stage.DragResize.prototype.pStart = null;
/** @private @type {null} */
com.inq.stage.DragResize.prototype.pLast = null;
/** @private @type {number} */
com.inq.stage.DragResize.prototype.touchIdentifier = null;
/** @private @type {number} */
com.inq.stage.DragResize.prototype.touchOffsetY = null;
/** @private @type {number} */
com.inq.stage.DragResize.prototype.touchOffsetX = null;
/** @private @type {number} */
com.inq.stage.DragResize.prototype.clickOffsetY = null;
/** @private @type {number} */
com.inq.stage.DragResize.prototype.clickOffsetX = null;
/** @private @type {null} */
com.inq.stage.DragResize.prototype.touch = null;
/** @private @type {string} */
com.inq.stage.DragResize.prototype.styleSaved = null;
/** @private @type {string} */
com.inq.stage.DragResize.prototype.cursor = null;
/** @private @type {js.HtmlDom} */
com.inq.stage.DragResize.prototype.root = null;
/** @private @type {js.HtmlDom} */
com.inq.stage.DragResize.prototype.dragImage = null;
/** @private @type {js.HtmlDom} */
com.inq.stage.DragResize.prototype.obj = null;
/** @type {string} */
com.inq.stage.DragResize.prototype.className = null;
/** @type {com.inq.stage.DragResize} */
com.inq.stage.DragResize.prototype.__class__ = com.inq.stage.DragResize;
com.inq.stage.DragResize.__interfaces__ = [com.inq.stage.IDragResize];
/** @private @type {number} */
com.inq.stage.DragResize.TOUCH_IDENTIFER_UNUSED = -1;

/** @private @type {string} */
com.inq.stage.DragResize.INSTANCE_LABEL = "instDragResize";

/** @private @type {js.HtmlDom} */
com.inq.stage.DragResize.doc = window.parent.document;

/** @type {null} */
com.inq.stage.DragResize.instance = null;

/** @type {string} */
com.inq.stage.DragResize.DEFAULT_BORDER_COLOR = "SlateGray";

